import React from 'react'
import { AllRoutes } from '../../Pages/AllRoutes/AllRoutes'

const Dashboard = () => {
  return (
    <div className='overflow'>
      <AllRoutes />
    </div>
  )
}

export default Dashboard
